import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// Página pública, sin login (Fase 3 del módulo de Evaluación y Hoja de Ruta — "modo
// presentación", enlace compartible). $token es el ID del doc en hojaDeRutaCompartida — alta
// entropía (crypto.randomUUID()), es la única autorización que hace falta para leerlo (ver
// firestore.rules) — mismo patrón ya usado en /consentimiento/$token.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/hoja-de-ruta/$token",
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: lazyRouteComponent(() => import("./hoja-de-ruta-page"), "HojaDeRutaPage"),
});
